/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getRecords.defs.js'
export { main as default } from './getRecords.defs.js'
